// Internal coercion helpers — not part of the public surface.
import type { TimeInput } from '../../types';

/** Coerce a {@link TimeInput} to epoch ms, or null when invalid. */
export function toEpochMs(input: TimeInput): number | null {
    if (typeof input === 'number') return Number.isFinite(input) ? input : null;
    const d = input instanceof Date ? input : new Date(input);
    const ms = d.getTime();
    return Number.isNaN(ms) ? null : ms;
}

/** Coerce a {@link TimeInput} to a Date, or null when invalid. */
export function toDate(input: TimeInput): Date | null {
    const ms = toEpochMs(input);
    return ms == null ? null : new Date(ms);
}
